import { freeUserUpgradeStep } from '../utils';

export const donorsListTour = {
  tourKey: 'donors_list',
  conditions: {
    orgTypes: ['npo'],
    userTypes: ['admin', 'staff'],
    plans: null,
  },
  steps: [
    {
      target: '[data-tour="donors-page"]',
      title: 'tours.donors-list.welcome.title',
      content: 'tours.donors-list.welcome.content',
      placement: 'top',
    },
    {
      target: '[data-tour="donors-tabs"]',
      title: 'tours.donors-list.tabs.title',
      content: 'tours.donors-list.tabs.content',
      placement: 'bottom',
    },
    freeUserUpgradeStep,
  ],
};
